export default __webpack_public_path__ + "static/logo-vegas-209e398980a84a1b85710b5747477d4a.png";